import React from 'react';
import UserAvatar from './UserAvatar';
import Tooltip from './Tooltip';

const MAX_VISIBLE = 4;
const SIZE = 20;

/** Overlapping avatar stack for "who else is here" presence indicators. */
export default function AvatarStack({ members, size = SIZE, className = '' }) {
  if (!members || members.length === 0) return null;

  const visible = members.slice(0, MAX_VISIBLE);
  const overflow = members.length - visible.length;

  return (
    <div
      className={`avatar-stack inline-flex items-center flex-shrink-0 ${className}`}
      style={{ paddingLeft: 4 }}
    >
      {visible.map((m, i) => (
        <Tooltip key={m.userId} content={m.name} side="bottom">
          <div
            style={{
              marginLeft: i === 0 ? 0 : -6,
              zIndex: visible.length - i,
              borderRadius: '50%',
              boxShadow: '0 0 0 2px var(--avatar-stack-ring, #fff)',
            }}
          >
            <UserAvatar userId={m.userId} name={m.name} size={size} />
          </div>
        </Tooltip>
      ))}
      {overflow > 0 && (
        <Tooltip content={`+${overflow} more`} side="bottom">
          <div
            className="flex items-center justify-center text-gray-600 bg-gray-200"
            style={{
              marginLeft: -6,
              zIndex: 0,
              width: size,
              height: size,
              borderRadius: '50%',
              fontSize: Math.max(9, Math.round(size * 0.36)),
              fontWeight: 600,
              boxShadow: '0 0 0 2px var(--avatar-stack-ring, #fff)',
            }}
          >
            +{overflow}
          </div>
        </Tooltip>
      )}
    </div>
  );
}
